import { useParams } from "react-router-dom";
import useMembers from "../../hooks/DatabseCollection/useMembers";
import MembersCard from "../MembersCard/MembersCard";

const MembersTab = () => {
  const { roomId } = useParams();
  const [membersData] = useMembers(roomId);

  return (
    <div className="sm:grid sm:grid-cols-4 sm:items-center sm:gap-7 space-y-5 sm:space-y-0">
      {membersData.map(
        ({
          id,
          data: { isAdmin, memberEmail, memberId, memberImage, memberName },
        }) => (
          <MembersCard
            key={id}
            isAdmin={isAdmin}
            memberEmail={memberEmail}
            memberId={memberId}
            memberImage={memberImage}
            memberName={memberName}
          />
        )
      )}
    </div>
  );
};

export default MembersTab;
